import { AfterViewInit, Component, Input, OnDestroy, OnInit, output, ViewChild } from '@angular/core';
import { FormsModule, NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { PhoneFormGroupType, PhoneInputComponent } from '@cargos/sprintpay-ui';
import { CustomMasks, CustomPatterns, CustomValidators } from '@cargos/sprintpay-utils';
import { IMaskModule } from 'angular-imask';
import { Subject, takeUntil } from 'rxjs';
import { blackListedCountryCodes } from '../../utils/constants';
import { InvalidFieldComponent } from '../field-error/field-error.component';
import { PersonalFormMaterialModule } from './form-personal-material.modules.module';
import { PersonalFormErrorJSON, PersonalFormGroupType, PersonalFormType } from './models/personal-form';
import { formPersonalErrors } from './utils/form-errors';
@Component({
    selector: 'app-form-personal',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        InvalidFieldComponent,
        FormsModule,
        IMaskModule,
        PersonalFormMaterialModule,
        PhoneInputComponent,
    ],
    templateUrl: './form-personal.component.html',
    styleUrl: './form-personal.component.scss',
})
export class FormPersonalComponent implements OnInit, AfterViewInit, OnDestroy {
    public personalForm: PersonalFormGroupType;
    public formErrors: PersonalFormErrorJSON;
    public maskPhone = CustomMasks.iMaskPhone;

    @Input() initialFormData?: PersonalFormType;
    readonly personalFormValueChanges = output<PersonalFormGroupType>();

    public blackListedCountryCodes = blackListedCountryCodes;
    public initialCountryCode: string = '';
    public initialPhone: string = '';
    public phoneForm!: PhoneFormGroupType;
    @ViewChild(PhoneInputComponent) PhoneInputComponent: PhoneInputComponent;
    private unsubscribe$: Subject<void>;
    constructor(private fb: NonNullableFormBuilder) {
        this.unsubscribe$ = new Subject<void>();
        this.formErrors = formPersonalErrors;
    }

    ngOnInit(): void {
        this.createForm();
        this.patchFormWithInitialData();
        this.subscribeToFormChanges();
    }
    ngAfterViewInit(): void {
        this.phoneForm = this.PhoneInputComponent?.phoneForm;
        this.getSyncingPhoneForm();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
    private subscribeToFormChanges(): void {
        this.personalForm.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
            this.personalFormValueChanges.emit(this.personalForm);
        });
    }
    /**
     * sync the phone input field values with current form element values
     */
    getSyncingPhoneForm(): void {
        this.personalForm.get('countryCode')?.setValue(this.PhoneInputComponent.getCountryCode());
        this.phoneForm
            .get('phone')
            ?.valueChanges.pipe(takeUntil(this.unsubscribe$))
            .subscribe((value: string) => {
                this.personalForm.get('phoneNumber')?.setValue(value);
            });
        this.phoneForm
            .get('code')
            ?.valueChanges.pipe(takeUntil(this.unsubscribe$))
            .subscribe(() => {
                this.personalForm.get('countryCode')?.setValue(this.PhoneInputComponent.getCountryCode());
            });
    }
    createForm(): void {
        this.personalForm = this.fb.group({
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            phoneNumber: ['', Validators.required],
            countryCode: ['US', Validators.required],
            email: ['', [Validators.required, CustomValidators.regex(new RegExp(CustomPatterns.EMAIL))]],
        });
    }

    resetData(): void {
        this.personalForm.reset();
    }

    validateNumbersFormat(event): void {
        let e = event || window.event;
        let key;

        if (e.type === 'paste') {
            let clipboard = e.clipboardData;
            key = clipboard.getData('text/plain');
        } else {
            key = e.keyCode || e.which;
            key = String.fromCharCode(key);
        }

        let regex = /[0-9]|\./;

        if (!regex.test(key)) {
            e.returnValue = false;
            e?.preventDefault();
        }
    }

    patchFormWithInitialData(): void {
        if (this.initialFormData) {
            this.personalForm.patchValue(this.initialFormData, {
                emitEvent: false,
            });
        }
    }

    /**
     * mark all phone-input form elements as touched when form submission trigged from the parent form/component.
     */
    onSubmit(): void {
        this.phoneForm.markAllAsTouched();
    }
}
